





























import {Component, Emit, Vue} from 'vue-property-decorator';
import {namespace, State} from 'vuex-class';
import {MAFUser} from '@/store/User/types';
import BButton from 'buefy/src/components/button/Button.vue';
import BField from 'buefy/src/components/field/Field.vue';
import BInput from 'buefy/src/components/input/Input.vue';
import luxon from '@/plugins/luxon';
import {DateTime} from 'luxon';
import * as _ from 'lodash';
import {message, UserWithMessage} from '@/store/Friends/types';

// TODO: fix this file so these rules don't need to be disabled
/* tslint:disable:no-empty */

const friendPath = 'friendState';
const friendNamespace = namespace(friendPath);

const userPath = 'userState';
const userNamespace = namespace(userPath);

@Component({
    components: {BButton, BField, BInput},
})
export default class UserChatView extends Vue {
    @userNamespace.State('self') public readonly self!: MAFUser;
    @friendNamespace.Getter('getFriendsAndMessages') public getFriendMessages!: UserWithMessage[];
    public BASE_URL: string;

    constructor() {
        super();
        this.BASE_URL = process.env.BASE_URL ? process.env.BASE_URL : '';

    }

    @Emit('user')
    public user(user: MAFUser) {
    }

    public getDate(mes: message) {
        return mes.formatDate();
    }

    get friendMessages(): UserWithMessage[] {
        return this.getFriendMessages;
    }

    @Emit('close')
    public close() {
    }
    public updateAvatar(friend: MAFUser) {
        if (friend && friend.avataarUrl !== '') {
            return friend.getAvataarUrl(this.BASE_URL, true);
        }
        if (friend && friend.imageURL !== '') {
            return friend.imageURL;
        }
    }

}
